package kz.dentalcrm.app.screens.employees.add.mvi

import kz.dentalcrm.app.core.base.ViewState
import kz.dentalcrm.app.core.ui.ScreenState
import kz.dentalcrm.app.data.network.response_model.employees.Position
import kz.dentalcrm.app.data.network.response_model.services.Service

data class AddEmployeeState(
    val name: String = "",
    val surname: String = "",
    val patronymic: String? = null,
    val phone: String = "",
    val gender: String = "",
    val birthDate: String = "",
    val color: String = "#0EA5E9",
    val selectedPositions: List<Position> = emptyList(),
    val selectedServices: List<Service> = emptyList(),
    val createAccount: Boolean = false,
    val roleId: Int = 2,
    
    // Available data from API
    val availablePositions: List<Position> = emptyList(),
    val availableServices: List<Service> = emptyList(),
    
    val screenState: ScreenState = ScreenState.Idle,
    
    // Account creation fields
    val email: String = "",
    val emailError: String = "",
    val password: String = "",
    val passwordError: String = "",
    val availablePermissions: List<kz.dentalcrm.app.data.network.response_model.permissions.Permission> = emptyList(),
    val selectedPermissions: List<kz.dentalcrm.app.data.network.response_model.permissions.Permission> = emptyList(),
    
    // Validation errors
    val nameError: String = "",
    val surnameError: String = "",
    val phoneError: String = ""
) : ViewState
